// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pm-1";
export var messageSideRight = "_pm-2";
export var orderLookupBubbleContainer = "_pm-0";
export var submitButton = "_pm-3";